import axios from "axios";

export interface ProjectViewModel {
  id: string;
  name: string;
}

export interface WorkflowSchemeViewModel {
  id: string;
  name: string;
  workflowSchemeUrl: string;
  projectUrl: string;
}

export const searchProjects = async (
  filter: string
): Promise<ProjectViewModel[]> => {
  const { data } = await axios.get<ProjectViewModel[]>(
    `${window.configuration.apiUrl}api/Projects/search?filter=${filter}&toolKey=JIRACLOUD`
  );
  return data;
};

export const copyWorkflowScheme = async (
  projectId: string
): Promise<WorkflowSchemeViewModel> => {
  const { data } = await axios.post<WorkflowSchemeViewModel>(
    `${window.configuration.apiUrl}api/Jira/copyWorkflowScheme`,
    { projectId }
  );
  return data;
};
